import { ForgeProjectMembership, ForgeProjectRole, } from "@supernova-studio/model";
import { zodQueryBoolean } from "../../../utils";
import { DTOUser } from "../users";
import { DTOCreateForgeProjectInvitation, DTOForgeProjectInvitation, } from "./project-invitation";
import { z } from "zod";
export const DTOForgeProjectMemberRole = ForgeProjectRole;
export const DTOForgeProjectMember = ForgeProjectMembership.extend({
    user: DTOUser,
    effectiveRole: DTOForgeProjectMemberRole,
    isDeactivated: z.boolean(),
});
export const DTOCreateForgeProjectMember = DTOForgeProjectMember.pick({
    userId: true,
    role: true,
});
export const DTOUpdateForgeProjectMember = DTOCreateForgeProjectMember;
export const DTORemoveForgeProjectMember = DTOForgeProjectMember.pick({
    userId: true,
});
export const DTOForgeProjectMemberListQuery = z.object({
    includeImplicitMembers: zodQueryBoolean().optional(),
});
export const DTOForgeProjectMembersListResponse = z.object({
    members: z.array(DTOForgeProjectMember),
    invitations: z.array(DTOForgeProjectInvitation),
});
export const DTOForgeProjectMemberGetResponse = z.object({
    member: DTOForgeProjectMember,
});
export const DTOForgeProjectMemberCreateResponse = z.object({
    member: DTOForgeProjectMember,
});
export const DTOForgeProjectMemberUpdateResponse = z.object({
    member: DTOForgeProjectMember.nullable(),
});
export const DTOForgeProjectMemberRemoveResponse = z.object({
    ok: z.literal(true),
});
export const DTOAddMembersToForgeProject = z.object({
    membersToInvite: DTOCreateForgeProjectInvitation.array().min(1),
    featureId: z.string().optional(),
});
